import React from "react";
import { toast as toastify, type Id } from "react-toastify";

export type ToastType = "success" | "error" | "info";

export type ToastItem = {
  id: string;
  type: ToastType;
  message: string;
  title?: string;
  durationMs?: number;
};

type ToastOptions = {
  title?: string;
  durationMs?: number;
};

// Обертка для совместимости с react-toastify
const renderToastContent = (
  message: string,
  title?: string
): React.ReactNode => {
  if (title) {
    const titleStyle: React.CSSProperties = {
      fontWeight: 600,
      marginBottom: "4px",
    };
    return React.createElement(
      "div",
      null,
      React.createElement("div", { style: titleStyle }, title),
      React.createElement("div", null, message)
    );
  }
  return message;
};

export const toast = {
  success(message: string, opts?: ToastOptions): string {
    const toastId: Id = toastify.success(
      renderToastContent(message, opts?.title),
      {
        autoClose: opts?.durationMs ?? 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      }
    );
    return String(toastId);
  },
  error(message: string, opts?: ToastOptions): string {
    const toastId: Id = toastify.error(
      renderToastContent(message, opts?.title),
      {
        autoClose: opts?.durationMs ?? 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      }
    );
    return String(toastId);
  },
  info(message: string, opts?: ToastOptions): string {
    const toastId: Id = toastify.info(
      renderToastContent(message, opts?.title),
      {
        autoClose: opts?.durationMs ?? 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      }
    );
    return String(toastId);
  },
  remove(id: string): void {
    toastify.dismiss(id);
  },
  dismiss(id: string): void {
    toastify.dismiss(id);
  },
  clear(): void {
    toastify.dismiss();
  },
};
